import PrevisionnelTourneeController from './previsionnel.tournee.controller';

export default {
    template: require('./previsionnel.tournee.html'),
    controller: PrevisionnelTourneeController
};
